import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6c0074ea&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=6c0074ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0074ea",
  null
  
)

export default component.exports